import { getCLS } from 'web-vitals/base';

const onCumulativeLayoutShift = response => {
  getCLS(cls => response(cls.value));
};

export default onCumulativeLayoutShift;
